module.exports = __webpack_public_path__ + "static/media/header.832b739c.mp3";